import { JdenticonConfig, toSvg } from 'jdenticon';
import { appThemeApiRef, useApi } from '@backstage/frontend-plugin-api';
import useObservable from 'react-use/lib/useObservable';

import styles from './AppIcon.module.css';

type AppIconProps = {
  appName: string;
  size?: number;
};

const iconConfig: JdenticonConfig = {
  hues: [207, 283, 64],
  lightness: {
    color: [0.45, 0.45],
    grayscale: [0.5, 0.75],
  },
  saturation: {
    color: 0.47,
    grayscale: 0.5,
  },
  backColor: '#ffffff00',
};

// jdenticon bakes colors into the SVG, so CSS can't recolor it. Raise the
// lightness so shapes stay vivid against a dark background.
const darkIconConfig: JdenticonConfig = {
  ...iconConfig,
  lightness: {
    color: [0.55, 0.7],
    grayscale: [0.4, 0.85],
  },
};

function useIsDarkMode() {
  const appThemeApi = useApi(appThemeApiRef);
  const themeId = useObservable(appThemeApi.activeThemeId$(), appThemeApi.getActiveThemeId());
  return themeId === 'dark';
}

export const AppIcon = ({ appName, size = 40 }: AppIconProps) => {
  const isDarkMode = useIsDarkMode();
  const config = isDarkMode ? darkIconConfig : iconConfig;
  const icon = { __html: toSvg(appName, size, config) };

  return <div className={styles.appIcon} dangerouslySetInnerHTML={icon} />;
};
